// @flow
import { isPluginModeWindow } from '../redux/common';
import cookieToken from './cookieToken';

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    return user !== false;
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    if (isPluginModeWindow()) {
        // Plugin mode - use the plugin token
        const user = cookieToken.getPluginToken();
        return typeof user === 'string' && user.trim().length > 0;
    }

    const user = cookieToken.get();

    return typeof user === 'string' && user.trim().length > 0;
};

export { isUserAuthenticated, getLoggedInUser };
